// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Field_full-width__IcJ0j {
  width: 100%;
}

.Field_half-width__edF5Q {
  width: 48%;
}

.Field_medium__Tsspl {
  width: 66%;
}

.Field_small__RWdGh {
  width: 30%;
}

.Field_field-caption__6ToAM {
  padding: 0.4em 0em;
  color: #7f7f7f;
  font-size: 0.8em;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/Field/Field.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;AACJ","sourcesContent":[".full-width {\n    width: 100%;\n}\n\n.half-width {\n    width: 48%;\n}\n\n.medium {\n    width: 66%;\n}\n\n.small {\n    width: 30%;\n}\n\n.field-caption {\n    padding: 0.4em 0em;\n    color: #7f7f7f;\n    font-size: 0.8em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"full-width": `Field_full-width__IcJ0j`,
	"half-width": `Field_half-width__edF5Q`,
	"medium": `Field_medium__Tsspl`,
	"small": `Field_small__RWdGh`,
	"field-caption": `Field_field-caption__6ToAM`
};
export default ___CSS_LOADER_EXPORT___;
